import {
  DefaultFetchError,
  FetchCreate,
  FetchDelete,
  FetchGet,
  FetchSuccess,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate,
  useFetchDelete,
  useFetchGet,
  useFetchUpdate,
} from "../fetch";

export interface User {
  id: string;
  role: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
}

export interface PhotoTag {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  user: User;
}

export interface PhotoTagTableRow extends PhotoTag {
  key: string;
  id: string;
  name: string;
}

export interface PhotoTagTableData {
  data: PhotoTagTableRow[];
  total: number;
}

export interface PhotoTagGetParams extends PagingParams {
  name?: string;
}

export interface PhotoTagCreateParams {
  name: string;
}

export const usePhotoTagGet = <DD = PagingDataResponse<PhotoTag>>(
  decorateData?: (data: PagingDataResponse<PhotoTag>) => DD,
): FetchGet<
  PagingDataResponse<PhotoTag>,
  PhotoTagGetParams,
  DefaultFetchError,
  DD
> =>
  useFetchGet("tag", {
    autoStart: false,
    startStateLoading: false,
    decorateData,
  });

export const usePhotoTagTableGet = () =>
  usePhotoTagGet<PhotoTagTableData>(
    ({ data, meta }: PagingDataResponse<PhotoTag>): PhotoTagTableData => ({
      data: data.map((item) => ({
        key: item.id,
        ...item,
      })),
      total: meta.itemCount,
    }),
  );

export const usePhotoTagCreate = (): FetchCreate<
  PhotoTagCreateParams,
  DefaultFetchError,
  PhotoTagCreateParams
> => useFetchCreate("tag");

export const usePhotoTagUpdate = (
  id?: string,
): FetchUpdate<PhotoTagCreateParams, DefaultFetchError, PhotoTagCreateParams> =>
  useFetchUpdate("tag", id);

export const usePhotoTagDelete = (
  id?: string,
): FetchDelete<FetchSuccess, DefaultFetchError> => useFetchDelete("tag", id);
